import React from "react";

const ProductDescription = ({ sortedProducts }) => {

    const productDescription = sortedProducts[0]?.descriptions[0];
    if (!productDescription) {
        console.log("Product description is missing.");
        return null;
    }
    return (
        <div className=' position-absolute top-0 end-0 w-100 product__description-three-view'>
            <div className='container fw-bold text-end'>
                <p>
                    Showing Product:{' '}
                    <span className='fw-normal'>{productDescription}</span>
                </p>
            </div>
        </div>
    )
}

export default ProductDescription;